const Faq = () => {
  return null;
};

export default Faq;
